<template>
  <div v-if="!closed" class="notice-line">
    <span>混雑状況表示が7日から8日間に増えました。&nbsp;[<a href="#" @click.prevent="closed = true">閉じる</a>]</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NoticeLine',
  data: function () {
    return {
      closed: false,
    }
  },
})
</script>

<style scoped lang="scss">
.notice-line {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  background-color: #E4E9EF;

  span, a {
    color: #000;
    font-size: 15px;
    font-weight: bold;
  }
}

@media screen and (max-width: 374px) {
  .notice-line {
    span, a {
      font-size: 12px;
    }
  }
}

@media screen and (min-width: 375px) and (max-width: 767px) {
  .notice-line {
    span, a {
      font-size: 14px;
    }
  }
}
</style>
